import React, { useEffect, useState } from 'react';
import { Breadcrumb, Button, Dropdown, Form, Icon, Menu, Segment } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import PageContainer from '../../common/PageContainer';
import { Link } from 'react-router-dom';
import * as campaignApi from '../../../api/campaignApi';

export const AddEmailTemplate = ({ addTemplate, getTemplateById, current, updateEmailTemplate, match, sites }) => {
  const id = match.params.id;
  const [audiences, setAudiences] = useState([]);

  useEffect(() => {
    getTemplateById(id);
  }, [id]);

  useEffect(() => {
    if (!current || current.id !== id) return;

    const toOption = audience => ({
      key: audience.id,
      value: audience.id,
      text: audience.name,
    });

    campaignApi
      .getMailchimpAudiences(current.siteId)
      .then(res => res.map(toOption))
      .then(setAudiences);
  }, [current]);

  const initialValues = { description: '', category: '', fromName: '', mailchimpListId: '', replyTo: '', siteId: '' };

  return (
    <Formik
      enableReinitialize
      initialValues={current?.id ? current : initialValues}
      // validationSchema={emailTemplateValidationSchema}
      onSubmit={updateEmailTemplate}
    >
      {formik => (
        <PageContainer>
          <Breadcrumb>
            <Link to="/admin/email-template">
              <Breadcrumb.Section content="Email templates" />
            </Link>
            <Breadcrumb.Divider icon="chevron right" />
            <Breadcrumb.Section content={id ? 'Edit email template' : 'Add email template'} />
          </Breadcrumb>

          <Menu borderless attached="top">
            <Menu.Item header>
              <Icon name="envelope outline" />
              {id ? 'Edit email template' : 'Create email template'}
            </Menu.Item>

            <Menu.Menu position="right">
              <Menu.Item>
                <Button
                  positive
                  icon="save"
                  type="submit"
                  content="Save"
                  labelPosition="left"
                  onClick={formik.handleSubmit}
                />
              </Menu.Item>
            </Menu.Menu>
          </Menu>

          <Segment>
            <Form onSubmit={formik.handleSubmit}>
              <TextField
                name="description"
                label="Description"
                formik={formik}
                value={formik.values.description}
                onChange={formik.handleChange}
                error={formik.touched.description && Boolean(formik.errors.description)}
                errorMessage={formik.errors.description}
              />
              <TextField
                name="category"
                label="Category"
                formik={formik}
                value={formik.values.category}
                onChange={formik.handleChange}
                error={formik.touched.category && Boolean(formik.errors.category)}
                errorMessage={formik.errors.category}
              />
              <TextField
                name="fromName"
                label="From Name"
                formik={formik}
                value={formik.values.fromName}
                onChange={formik.handleChange}
                error={formik.touched.fromName && Boolean(formik.errors.fromName)}
                errorMessage={formik.errors.fromName}
              />

              <Form.Field>
                <label>Mailchimp Audience</label>
                <Dropdown
                  name="mailchimpListId"
                  label="Mailchimp List"
                  fluid
                  clearable
                  selection
                  options={audiences}
                  formik={formik}
                  value={formik.values.mailchimpListId}
                  onChange={(e, { value }) => formik.setFieldValue('mailchimpListId', value)}
                  error={formik.touched.mailchimpListId && Boolean(formik.errors.mailchimpListId)}
                />
              </Form.Field>

              <TextField
                name="replyTo"
                label="Reply To"
                formik={formik}
                value={formik.values.replyTo}
                onChange={formik.handleChange}
                error={formik.touched.replyTo && Boolean(formik.errors.replyTo)}
                errorMessage={formik.errors.replyTo}
              />

              <Form.Field>
                <label>Site</label>
                <Dropdown
                  name="siteId"
                  label="Site Id"
                  selection
                  clearable
                  formik={formik}
                  value={formik.values.siteId}
                  onChange={formik.handleChange}
                  error={formik.touched.siteId && Boolean(formik.errors.siteId)}
                  errorMessage={formik.errors.siteId}
                  options={sites}
                />
              </Form.Field>
            </Form>
            <br />
            <br />
            <br />
          </Segment>
        </PageContainer>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  current: selectors.getCurrentEmailTemplate(state),
  sites: selectors.admin.siteOptions(state),
});

const mapDispatchToProps = dispatch => ({
  addTemplate: bindActionCreators(actions.admin.addEmailTemplate, dispatch),
  getTemplateById: bindActionCreators(actions.admin.getTemplateById, dispatch),
  updateEmailTemplate: bindActionCreators(actions.admin.updateEmailTemplate, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEmailTemplate);
